import { useNavigate } from "react-router";
import { useSearchParams } from "react-router-dom";
import React, { useContext, useEffect } from "react";

import { AuthContext, LoadingContext } from "../Context";

const ImpersonatePage = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  // ==================================================================================================

  const { setLoading } = useContext(LoadingContext);
  const { setToken } = useContext(AuthContext);

  // ==================================================================================================

  useEffect(() => {
    const token = searchParams.get("token");
    setLoading(true);
    if (token) {
      localStorage.setItem("Token", token);
      setToken(token);
      setLoading(false);
      navigate("/profile");
    } else {
      setLoading(false);
      navigate("/");
    }
  }, []);

  // ==================================================================================================

  return <></>;
};

export default ImpersonatePage;
